import { useTimer } from "react-timer-hook";
import swal from "sweetalert";
import Loc from "../../Loc/Loc";

interface MyTimerProps {
    expiryTimestand: Date;
}

export default function MyTimer(props: MyTimerProps) {
    const {
        seconds,
        minutes,
        // hours,
        // days,
        // isRunning,
        // start,
        // pause,
        // resume,
        // restart,
    } = useTimer({ expiryTimestamp: props.expiryTimestand, onExpire: () => swal({ title: Loc.trad().MyTimerExpired, icon: "error" }) });

    return (
        <div style={{ textAlign: 'center', color: '#3abad9' }}>
            <div style={{ fontSize: '100px' }}>
                <span>{minutes}</span>:<span>{seconds < 10 ? "0" + seconds.toString() : seconds}</span>
            </div>
        </div>
    );
}